import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { getProductDepartments } from '../../utils/departments';

export default function Dashboard() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    api.get('/products')
      .then(res => setProducts(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));

    api.get('/admin/visits/stats')
      .then(res => setVisits(res.data))
      .catch(() => {});
  }, []);

  const visitCards = [
    { label: 'Visitas Hoje', key: 'day' },
    { label: 'Visitas na Semana', key: 'week' },
    { label: 'Visitas no Mês', key: 'month' },
    { label: 'Total de Visitas', key: 'total' },
  ];

  const total = products.length;
  const destaque = products.filter(p => p.featured).length;
  const departamentos = new Set(products.flatMap(p => getProductDepartments(p))).size;
  const recentes = [...products].reverse().slice(0, 5);

  return (
    <>
      <h1 className="page-title">Dashboard</h1>

      <h2 className="section-title">Visitas ao Site</h2>
      <div className="stats-grid stats-grid-4">
        {visitCards.map(c => (
          <div key={c.key} className="stat-card">
            <h3>{c.label}</h3>
            <div className="stat-value">
              {visits ? visits[c.key].toLocaleString('pt-BR') : '—'}
            </div>
          </div>
        ))}
      </div>

      <h2 className="section-title">Produtos</h2>
      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total de Produtos</h3>
          <div className="stat-value">{loading ? '—' : total}</div>
        </div>
        <div className="stat-card">
          <h3>Produtos em Destaque</h3>
          <div className="stat-value">{loading ? '—' : destaque}</div>
        </div>
        <div className="stat-card">
          <h3>Departamentos</h3>
          <div className="stat-value">{loading ? '—' : departamentos}</div>
        </div>
      </div>

      <h2 className="section-title">Últimos Produtos Cadastrados</h2>
      <div className="recent-products-list">
        {loading && (
          <div className="recent-product-item">
            <span style={{ color: '#999' }}>Carregando...</span>
          </div>
        )}
        {!loading && recentes.length === 0 && (
          <div className="recent-product-item">
            <span style={{ color: '#999' }}>Nenhum produto cadastrado.</span>
          </div>
        )}
        {recentes.map(p => (
          <div key={p._id} className="recent-product-item">
            <div>
              <p className="recent-product-name">{p.name}</p>
              <p className="recent-product-sub">
                {getProductDepartments(p).join(', ') || 'Sem departamento'} — R$ {p.price?.toFixed(2)}
              </p>
            </div>
            <span className={p.featured ? 'badge-destaque' : 'badge-normal'}>
              {p.featured ? 'Em Destaque' : 'Normal'}
            </span>
          </div>
        ))}
      </div>
    </>
  );
}
